export const fcComma = function(str) {
  //number comma
  str = String(str);
  return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
};

export const fcRemoveLastComma = function(str){
  return str.replace(/,\s*$/, "");
};

export const fcNowDay = function(date) {
  var cons_date = new Date(date);
  var today = new Date();
  var day_val = 3600 * 24 * 1000;
  var start = Math.floor(cons_date.getTime() / day_val);
  var end = Math.floor(today.getTime() / day_val);

  return end - start;
};

export const fcNow = function() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth()+1; //January is 0!
  var yyyy = today.getFullYear();

  if(dd<10) {
    dd='0'+dd
  }

  if(mm<10) {
    mm='0'+mm
  }

  today = yyyy+'-'+mm+'-'+dd;
  return today;
}

export const fcNowDate = function() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth()+1; //January is 0!
  var yyyy = today.getFullYear();
  var hh = today.getHours();
  var ii = today.getMinutes();
  var ss = today.getSeconds();

  if(dd<10) {
    dd='0'+dd
  }

  if(mm<10) {
    mm='0'+mm
  }

  if(ii<10) {
    ii='0'+ii
  }

  today = yyyy+'-'+mm+'-'+dd+" "+hh+":"+ii+":"+ss;
  return today;
}

export const fcCommuDate = function(date) {
  let date_sub = date.split(" ");
  let time = date_sub[1].split(":");
  if(time[0] > 12) {
    return date_sub[0]+" 오후 "+time[0]+":"+time[1];
  } else {
    return date_sub[0]+" 오전 "+time[0]+":"+time[1];
  }
}

export const fcSecondsToTime = function(second){ // 시간을 초로 변환
  return Math.floor(second / 3600);
};

export const fcTimeToSecond = function(time){ // 시간을 초로 변환
  return Math.floor(time * 3600);
};


export const fcKeyByValue = function (object, value) { // object에 value를 비교 후 키를 리턴
  return Object.keys(object).find(key => object[key] === value);
};

//flag == 1 같을때, flag == 2 같지 않을때
export const fcArrayFilter = function(array, key, value, flag = 1)  { // 필터 기능
  let key_Array = key.split(".");
  let ReturnArray = array.filter(function(item) {
    let item_Array = [];
    for(let i = 0 ; i < key_Array.length; i++) {
      if(item.hasOwnProperty(key_Array[i])) {
        item = item[key_Array[i]];
        if(Array.isArray(item)) {
          for(let j = 0 ; j < item.length ; j ++) {
            let i_value = i + 1;
            let cut_item = item[j][key_Array[i_value]];
            while((key_Array.length - 1) != i_value) {
              cut_item = cut_item[key_Array[i]];
              i_value ++;
            }
            item_Array.push(cut_item);
          }
          break;
        }
      } else {
        return false;
      }
    }
    if(item_Array.length > 0 ){
      let ItemStatus = false;
      for(let i = 0 ; i < item_Array.length ; i ++) {
        if(!isNaN(item_Array[i])) {
          if(flag === 1) {
            if(item_Array[i]===value) {
              ItemStatus = true;
              break;
            }
          } else {
            if(item_Array[i]!==value) {
              ItemStatus = true;
              break;
            }
          }
        } else {
          if(flag === 1) {
            if(item_Array[i].indexOf(value) > -1) {
              ItemStatus = true;
              break;
            }
          } else {
            if(item_Array[i].indexOf(value) == -1) {
              ItemStatus = true;
              break;
            }
          }
        }
      }
      return ItemStatus;
    } else {
      if(!isNaN(item) || typeof(item) !== 'string') {
        if(flag === 1) {
          return item===value;
        } else {
          return item!==value;
        }
      } else {
        if(flag === 1) {
          return item.indexOf(value) > -1;
        } else {
          return item.indexOf(value) == -1;
        }
      }
    }
  });

  return ReturnArray;
}

//예제 data, {age: 'desc', name: 'asc', total: 'desc'}
export const multiSort = function(array, sortObject = {}) { //sort 기능
  const sortKeys = Object.keys(sortObject);

  // Return array if no sort object is supplied.
  if (!sortKeys.length) {
    return array;
  }

  // Change the values of the sortObject keys to -1, 0, or 1.
  for (let key in sortObject) {
    sortObject[key] = sortObject[key] === 'desc' || sortObject[key] === -1 ? -1
      : (sortObject[key] === 'skip' || sortObject[key] === 0 ? 0 : 1);
  }

  const keySort = (a, b, direction) => {
    direction = direction !== null ? direction : 1;

    if (a === b) { // If the values are the same, do not switch positions.
      return 0;
    }

    // If b > a, multiply by -1 to get the reverse direction.
    return a > b ? direction : -1 * direction;
  };

  return array.sort((a, b) => {
    let sorted = 0;
    let index = 0;

    // Loop until sorted (-1 or 1) or until the sort keys have been processed.
    while (sorted === 0 && index < sortKeys.length) {
      const key = sortKeys[index];

      if (key) {
        const direction = sortObject[key];
        let key_Array = key.split(".");
        for(let i = 0 ; i < key_Array.length; i++) {
          a = a[key_Array[i]];
          b = b[key_Array[i]];
        }
        sorted = keySort(a, b, direction);
        index++;
      }
    }
    return sorted;
  });
}

export const fcDomRemove = function(element) {
  element && element.parentNode && element.parentNode.removeChild(element);
}

export const fcFormatBytes = function(a, b){
  if(0==a)return"0 Bytes";var c=1024,d=b||2,e=["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"],f=Math.floor(Math.log(a)/Math.log(c));return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f];
}


export const isValidProtocol = function(s) {
  //프로토콜 유무 체크
  var protocol_exist_check = /^(?:(?:\w+):\/\/){1}/;
  //허가된 프로토콜 체크
  var protocol_granted = /^(http|https|ftp?):\/\/([^:\/\s]+)/;

  if (protocol_exist_check.test(s)) {
    if (!protocol_granted.test(s)) {
      s = "";
    }
  } else {
    s = "http://" + s;
  }

  return s;
}

export const isUrl = function(s) {
  var protocol_regex = /^(?:(?:\w+):\/\/){1}/;
  var granted_protocol = /^(http|https|ftp?):\/\/([^:\/\s]+)/;
  var special_char = /[\.\!\@\#\$\%\^\&\*\(\)\+\~\\\;\[\]\'\,\.\:\/\{\}\\<\>\?\`\|]/;
  var port_regex = /(\:\d+)/;

  var host = "";
  var host_split = [];
  var host_search = [];
  var split_delim = '.';

  //프로토콜 체크 및 없을시 추가
  s = isValidProtocol(s);

  if (s == "") {
    //프로토콜 형식 오류
    return false;
  }

  //프토토콜 저장
  var protocol = s.match(protocol_regex);
  //hostname 정보 분리
  var host = s.replace(protocol[0], "");

  //hostname의 마지막이 /인지 ?인지 분리
  if (host.indexOf("/") != -1) {
    host_search = host.split("/");
    host = host_search[0];
  }
  //GET 요청 파라미터(?) 분리
  else if (host.indexOf("?") != -1) {
    host_search = host.split("?");
    host = host_search[0];
  }

  //.(점) 으로 hostname split 후 개별 레이블 특수문자 체크
  host_split = host.split(split_delim);

  //서브 도메인 depth 체크
  if (host_split.length > 127 || host_split.length == 0) {
    return false;
  }

  //최상위 도메인이 없는경우 ex)naver.com -> 정상, navercom->걸림
  if (host_split.length < 2) {
    return false;
  }

  //전체 도메인 길이가 253자 이상일 경우 hostname 형식 위반으로 종료
  if (host.length > 253) {
    return false;
  }


  //hostname에 허용 안되는 특수문자 포함되는지 확인
  for (var i = 0; i < host_split.length; i++) {
    //개별 레이블 개수가 63개 이상일 경우 hostname 형식 위반이므로 종료
    if (host_split[i].length > 63) {
      return false;
    }


    //hostname에서 허가되지 않은 특수문자 있는지 체크
    if (special_char.test(host_split[i])) {
      if (i != host_split.length - 1) {
        //hostname에 허용 안되는 특문 포함
        //허용안되는 특문 포함시 리턴후 메소드 종료
        return false;
      } else {
        //마지막 hostname일 경우 포트 형식이 아니면 오류로 판단
        if (!port_regex.test(host_split[i])) {
          return false;
        }
      }
    }
  }

  //위의 모든 단계 통과시 url 형식으로 판단
  return true;
}

export const ArrayMerge = function(array1, array2, eqFlag) {
  let arrayTot = array1.concat(array2);
  let ArrayResult = null;
  if(eqFlag) {
    ArrayResult = arrayTot.reduce(function(a,b){
      if (a.indexOf(b) < 0 ) a.push(b);
      return a;
    },[]);
  } else {
    ArrayResult = arrayTot;
  }
  return ArrayResult;
}

export const fcCheckEmail = function(email){
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const ReplaceHtml = function(value) {
  return value.replace(/\r?\n/g, '<br />');
}
